module.exports = __webpack_public_path__ + "img/hr-dead-dry-hairy-tree-10.b33c1b1d.png";